import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "@/context/LanguageContext";

export default function CookieBanner() {
  const { t } = useLanguage();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("useko_cookie_consent");
    if (!consent) setTimeout(() => setShow(true), 1200);
  }, []);

  const accept = (value) => {
    localStorage.setItem("useko_cookie_consent", value);
    setShow(false);
  };

  if (!show) return null;
  return (
    <div className="fixed bottom-4 inset-x-4 md:inset-x-auto md:end-6 md:max-w-md z-50 bg-white border border-[#E5E7EB] rounded-2xl shadow-2xl p-5 fade-up" data-testid="cookie-banner">
      <p className="text-sm text-[#102A43] leading-relaxed">{t.cookie_msg}</p>
      <p className="mt-2 text-xs text-[#4B5563]">
        <Link to="/cerez-politikasi" className="underline underline-offset-2 hover:text-[#1F8A5B]">{t.cookies}</Link>
      </p>
      <div className="mt-4 flex gap-2">
        <button onClick={() => accept("all")} className="btn-primary !py-2 !px-4 text-xs flex-1 justify-center" data-testid="cookie-accept">{t.cookie_accept}</button>
        <button onClick={() => accept("essential")} className="btn-outline !py-2 !px-4 text-xs flex-1 justify-center" data-testid="cookie-decline">{t.cookie_decline}</button>
      </div>
    </div>
  );
}
